import React, { useState } from 'react';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    enquiry: '',
    subject: '',
    question: '',
  });

  const enquiries = [
    'General Inquiry',
    'Support',
    'Sales',
    'Partnership',
    'Other',
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you can handle form submission (e.g. API call)
    alert('Form submitted!');
  };

  return (
    <form 
  onSubmit={handleSubmit} 
  className="w-full m-0 p-0 space-y-6"
>
      {/* First and Last Name side by side */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-semibold mb-1" htmlFor="firstName">
            [FIRST NAME] <span className="text-red-600">*</span>
          </label>
          <input
            id="firstName"
            name="firstName"
            type="text"
            required
            value={formData.firstName}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#4f0594]"
          />
        </div>
        <div>
          <label className="block text-sm font-semibold mb-1" htmlFor="lastName">
            [LAST NAME] <span className="text-red-600">*</span>
          </label>
          <input
            id="lastName"
            name="lastName"
            type="text"
            required
            value={formData.lastName}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#4f0594]"
          />
        </div>
      </div>

      {/* Email */}
      <div>
        <label className="block text-sm font-semibold mb-1" htmlFor="email">
          [EMAIL] <span className="text-red-600">*</span>
        </label>
        <input
          id="email"
          name="email"
          type="email"
          required
          value={formData.email}
          onChange={handleChange}
          className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#4f0594]"
        />
      </div>

      {/* Phone */}
      <div>
        <label className="block text-sm font-semibold mb-1" htmlFor="phone">
          [PHONE] <span className="text-red-600">*</span>
        </label>
        <input
          id="phone"
          name="phone"
          type="tel"
          required
          value={formData.phone}
          onChange={handleChange}
          className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#4f0594]"
        />
      </div>

      {/* Enquiry Dropdown */}
      <div>
        <label className="block text-sm font-semibold mb-1" htmlFor="enquiry">
          [ENQUIRY] <span className="text-red-600">*</span>
        </label>
        <select
          id="enquiry"
          name="enquiry"
          required
          value={formData.enquiry}
          onChange={handleChange}
          className="w-full border border-gray-300 rounded-md px-3 py-2 bg-white focus:outline-none focus:ring-2 focus:ring-[#4f0594]"
        >
          <option value="">Select</option>
          {enquiries.map((option, i) => (
            <option key={i} value={option}>{option}</option>
          ))}
        </select>
      </div>

      {/* Subject */}
      <div>
        <label className="block text-sm font-semibold mb-1" htmlFor="subject">
          [SUBJECT] <span className="text-red-600">*</span>
        </label>
        <input
          id="subject"
          name="subject"
          type="text"
          required
          value={formData.subject}
          onChange={handleChange}
          className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#4f0594]"
        />
      </div>

      {/* Your Question */}
      <div>
        <label className="block text-sm font-semibold mb-1" htmlFor="question">
          [YOUR QUESTION] <span className="text-red-600">*</span>
        </label>
        <textarea
          id="question"
          name="question"
          required
          rows="5"
          value={formData.question}
          onChange={handleChange}
          className="w-full border border-gray-300 rounded-md px-3 py-2 resize-none focus:outline-none focus:ring-2 focus:ring-[#4f0594]"
        />
      </div>

      {/* Submit Button */}
      <div>
        <button
  type="submit"
  className="
    inline-block px-8 py-3 
    border-2 border-purple-500 
    text-purple-600 
    bg-white 
    rounded-md 
    font-semibold 
    transition-all duration-200

    hover:bg-[#4B0082] 
    hover:text-white 
    hover:border-[#4B0082]
  "
  style={{ fontFamily: 'Calibri, sans-serif' }}
>
  Submit
</button>
      </div>
    </form>
  );
};

export default ContactForm;
